import { z } from "zod";
export const AssetReference = z.object({
    id: z.string(),
    designSystemVersionId: z.string(),
    assetId: z.string(),
    persistentId: z.string(),
});
